import { Tag } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class Version extends Tag {
    static of(version) {
        return new Version(version);
    }
    _version;
    constructor(version) {
        super();
        this._version = version;
    }
    get type() {
        return "version";
    }
    get version() {
        return this._version;
    }
    equals(value) {
        return value instanceof Version && value._version === this._version;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            version: this._version,
        };
    }
}
/**
 * @public
 */
(function (Version) {
    function isVersion(value) {
        return value instanceof Version;
    }
    Version.isVersion = isVersion;
})(Version || (Version = {}));
//# sourceMappingURL=version.js.map